<template>
    <span :class="{ 'text-slate-400': cpp === '--' }">{{ cpp }}</span>
</template>
<script setup>
import { computed } from 'vue';

const props = defineProps({
    redemption: {
        type: Object,
    },
});

const cpp = computed(() => {
    let val = 0;
    let points =
        props.redemption?.transfer_points || props.redemption?.payment_points;

    if (props.redemption?.payment_type === 'points') {
        val =
            (parseFloat(props.redemption?.advertised_price) /
                parseFloat(points)) *
            100;
    }

    if (props.redemption?.payment_type === 'cash_points') {
        val =
            ((parseFloat(props.redemption?.advertised_price) -
                parseFloat(props.redemption?.payment_cash_amount)) /
                parseFloat(points)) *
            100;
    }

    return val ? val.toFixed(1) : '--';
});
</script>
